import { Alert, Box } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import ArticlesApi from '../../../apis/ArticlesApi';
import ArticleCard from '../../../components/ArticleCard/ArticleCard';
import LoadingCircle from '../../../components/LoadingCircle/LoadingCircle';
import SnackbarContext from '../../../contexts/SnackbarContext';
import { ArticleCardDto } from '../../../generated-types/articleCardDto';
import useApi from '../../../lib/useApi';

/**
 * The article list shows previews of all the articles within the article view
 */
const ArticleList = () => {
  const [articlePreviews, setArticlePreviews] = useState<ArticleCardDto[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const articlesApi = useApi(ArticlesApi);
  const snackbarContext = useContext(SnackbarContext);

  useEffect(() => {
    setIsLoading(true);
    articlesApi
      .GetArticleCards()
      .then((all) => {
        const latestArticles = all.sort(
          (a, b) =>
            new Date(b.written).getTime() - new Date(a.written).getTime()
        ); // Sort by date descending
        setArticlePreviews(latestArticles);
      })
      .catch(() => {
        snackbarContext.setAlert(
          <Alert severity="error" variant="filled">
            Error loading the articles. Please try again. If this continues, try
            again later!
          </Alert>
        );
        snackbarContext.triggerSnackbar();
      })
      .finally(() => setIsLoading(false));
  }, [articlesApi, snackbarContext]);

  return (
    <Box position="relative" minHeight="5em">
      {articlePreviews.length == 0 && !isLoading ? (
        <Box marginTop="2em" textAlign="center">
          No articles have been loaded. Try again later!
        </Box>
      ) : (
        articlePreviews.map((a, i) => <ArticleCard key={i} {...a} />)
      )}
      <LoadingCircle
        isLoading={isLoading}
        hideBackgroundShadow
        loadingText="Loading articles..."
      />
    </Box>
  );
};

export default ArticleList;
